export const CAC_WARNING_WHITELISTED_TENANTS = [
  'pb7q.onmicrosoft.com',
  'dope.security',
  'gruner.ch',
  'gruner.onmicrosoft.com',
]
